import React from 'react';
import { BaseStore } from './base';
import { LangStore } from './lang';
import { GodStore } from './god';
import { DevStore } from './dev';
import { TransactionStore } from './transaction';
import { IotexStore } from './iotex';
import { EthStore } from './eth';
import { SettingStore } from './setting';

export const rootStore = {
  base: new BaseStore(),
  lang: new LangStore(),
  god: new GodStore(),
  iotex: new IotexStore(),
  eth: new EthStore(),
  dev: new DevStore(),
  transaction: new TransactionStore(),
  setting: new SettingStore()
};

const StoresContext = React.createContext(rootStore);

export const useStore = () => React.useContext(StoresContext);

//@ts-ignore
window._store = rootStore;
